import { PUSH_EVENTS_LOG } from '../actionTypes';

export const pushEventsLog = data => {
  return {
    type: PUSH_EVENTS_LOG,
    data,
  };
};
